import { TextMetrics, Graphics } from 'pixi.js';
import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import AnimateEntrance from '../helper/animate';
import { getCurrencySymbol } from '../helper/currencies';
import { QuestStatusBarView } from '../../view/quest/QuestStatusBar';

class PromptController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.interaction = true;
		AnimateEntrance(this.vc);
		if (this.vc[this.config.holder]) {
			this.wrapper = this.vc[this.config.holder];
			this.wrapper.PROMPT_YES.handler = this.handler.bind(this);
			this.wrapper.PROMPT_NO.handler = this.close.bind(this);
			window.sm.play({ name: 'bonus_buy_quest_open_sfx' });
			this.enabled = true;
			this.reels = GameConfigs.reelComponent;
			this.currency = getCurrencySymbol(
				GameConfigs.auth.balance.currency,
				true
			);
			this.generatePrize();
			//???
			window.addEventListener(EVENTS.NOTIFICATION, this, false);
			if (
				GameConfigs.settings.keyboard_shortcuts &&
				!window.isMobile &&
				!window.isTablet
			) {
				window.addEventListener('keydown', this, false);
			}
		} else {
			throw new Error(
				'PromptController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.NOTIFICATION:
				this.close();
				window.removeEventListener(EVENTS.NOTIFICATION, this, false);
				break;
			case 'keydown':
				if (
					evt.keyCode === 27 ||
					(evt.keyCode === 32 && !GameConfigs.disabled.spin)
				) {
					if (GameConfigs.modal === 'prompt') {
						this.close();
					}
					window.removeEventListener(EVENTS.NOTIFICATION, this, false);
					window.removeEventListener('keydown', this, false);
				}
				break;
			default:
				break;
		}
	}

	generatePrize() {
		if (GameConfigs.quest_claim.item) {
			switch (GameConfigs.quest_claim.item.prize.type) {
				case 'bonus_game':
					this.generateBonusGame();
					break;
				case 'bonus_discount':
					this.generateBonusDiscount();
					break;
				case 'wild_respin':
					this.generateWildRespin();
					break;
				case 'bet_discount':
					this.generateBetDiscount();
					break;

				case 'win_multiplier':
					this.generateWinMultiplier();
					break;
				default:
					break;
			}
		}
	}

	generateBonusGame() {
		this.wrapper.PROMPT_DESC.text = 'YOUR NEXT SPIN WILL BE A';
		this.wrapper.PROMPT_PRIZE.text = this.capitalizeWords(
			GameConfigs.quest_claim.item.prize.type
		);
		this.wrapper.PROMPT_PRIZE_DESC.text = 'SPIN PRICE';
		const amount = GameConfigs.config.bet_steps[
			GameConfigs.quest_claim.bet_level !== ''
				? GameConfigs.quest_claim.bet_level
				: 0
		].toLocaleString(undefined, {
			minimumFractionDigits: GameConfigs.config.currency_prec,
			maximumFractionDigits: GameConfigs.config.currency_prec
		});
		if (this.currency[1] === 'left') {
			this.wrapper.PROMPT_AMOUNT.text = this.currency[0] + amount;
		} else {
			let finalAmount;
			if (GameConfigs.config.balance.currency === 'GEL') {
				finalAmount = amount + this.currency[0];
			} else {
				finalAmount = amount + ' ' + this.currency[0];
			}
			this.wrapper.PROMPT_AMOUNT.text = finalAmount;
		}
	}

	generateBonusDiscount() {
		let line = new Graphics();
		line.clear();
		line.lineStyle(3, 0x29c6c8, 1);

		this.wrapper.PROMPT_DESC.text = `YOU WILL GET ${GameConfigs.quest_claim.item.prize.config.discount}% DISCOUNTED`;

		this.wrapper.PROMPT_PRIZE_DESC_1.text = 'YOU WILL GET AT LEAST';
		this.wrapper.PROMPT_PRIZE_DESC_2.text = 'BONUS SPINS';

		this.wrapper.PROMPT_PRIZE_DESC_1.position.x = 195;

		this.wrapper.PROMPT_PRIZE.text = GameConfigs.config.minfs;

		const PROMPT_PRIZE_DESC_1_WIDTH = TextMetrics.measureText(
			this.wrapper.PROMPT_PRIZE_DESC_1.text,
			this.wrapper.PROMPT_PRIZE_DESC_1.style
		).width;
		this.wrapper.PROMPT_PRIZE.position.x = PROMPT_PRIZE_DESC_1_WIDTH + 82;
		this.wrapper.PROMPT_PRIZE_DESC_2.position.x =
			PROMPT_PRIZE_DESC_1_WIDTH + 190;

		this.wrapper.PROMPT_PRIZE_DESC.text = 'AT COST OF';

		const PROMPT_PRIZE_DESC_WIDTH = TextMetrics.measureText(
			this.wrapper.PROMPT_PRIZE_DESC.text,
			this.wrapper.PROMPT_PRIZE_DESC.style
		).width;
		this.wrapper.PROMPT_PRIZE_DESC.position.x =
			this.wrapper.getBounds().width / 2 - 70;

		const discountedPrice =
			GameConfigs.config.buyfeatureprice *
			GameConfigs.config.bet_steps[
				GameConfigs.quest_claim.bet_level !== ''
					? GameConfigs.quest_claim.bet_level
					: 0
			];
		if (this.currency[1] === 'left') {
			this.wrapper.PROMPT_PRIZE_DISCOUNT.text =
				this.currency[0] + discountedPrice;
		} else {
			this.wrapper.PROMPT_PRIZE_DISCOUNT.text =
				discountedPrice +
				(GameConfigs.auth.balance.currency === 'GEL'
					? '' + this.currency[0]
					: ' ' + this.currency[0]);
		}

		this.wrapper.PROMPT_PRIZE_DISCOUNT.position.x =
			this.wrapper.PROMPT_PRIZE_DESC.getBounds().x +
			PROMPT_PRIZE_DESC_WIDTH +
			10;
		this.wrapper.PROMPT_PRIZE_DISCOUNT.alpha = 0.5;

		const amount =
			(discountedPrice * GameConfigs.quest_claim.item.prize.config.discount) /
			100;
		if (this.currency[1] === 'left') {
			this.wrapper.PROMPT_AMOUNT.text = this.currency[0] + amount;
		} else {
			this.wrapper.PROMPT_AMOUNT.text =
				amount +
				(GameConfigs.auth.balance.currency === 'GEL'
					? '' + this.currency[0]
					: ' ' + this.currency[0]);
		}

		let x =
			this.wrapper.PROMPT_PRIZE_DISCOUNT.getBounds().width / 1.3 +
			this.wrapper.PROMPT_PRIZE_DISCOUNT.position.x;
		let y = this.wrapper.PROMPT_PRIZE_DISCOUNT.position.y + 15;
		line.moveTo(this.wrapper.PROMPT_PRIZE_DISCOUNT.position.x, y);
		line.lineTo(x, y);
		this.wrapper.addChild(line);
	}

	generateWildRespin() {
		this.wrapper.PROMPT_DESC.text = `YOU WILL GET`;
		this.wrapper.PROMPT_PRIZE.text =
			GameConfigs.quest_claim.item.prize.count -
			GameConfigs.quest_claim.item.claimed;

		if (
			GameConfigs.quest_claim.item.prize.count -
				GameConfigs.quest_claim.item.claimed >
			9
		) {
			this.wrapper.PROMPT_PRIZE.position.x =
				this.wrapper.getBounds().width / 2 - 84;
		} else {
			this.wrapper.PROMPT_PRIZE.position.x =
				this.wrapper.getBounds().width / 2 - 72;
		}
		this.wrapper.PROMPT_PRIZE_DESC_2.text = 'WILD SPINS';
		this.wrapper.PROMPT_PRIZE_DESC_2.position.x =
			this.wrapper.getBounds().width / 2 + 22;
		this.wrapper.PROMPT_PRIZE_DESC.text = 'SPIN PRICE';
		if (this.currency[1] === 'left') {
			this.wrapper.PROMPT_AMOUNT.text =
				this.currency[0] +
				GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level];
		} else {
			this.wrapper.PROMPT_AMOUNT.text =
				GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level] +
				(GameConfigs.auth.balance.currency === 'GEL'
					? '' + this.currency[0]
					: ' ' + this.currency[0]);
		}
	}

	generateWinMultiplier() {
		this.wrapper.PROMPT_DESC.text = `YOU WILL GET ${GameConfigs.quest_claim.item.prize.config.multiplier}X WIN ON`;
		this.wrapper.PROMPT_PRIZE.text =
			GameConfigs.quest_claim.item.prize.count -
			GameConfigs.quest_claim.item.claimed;
		this.wrapper.PROMPT_PRIZE.anchor.x = 1;
		this.wrapper.PROMPT_PRIZE.position.x = this.wrapper.getBounds().width / 2;
		this.wrapper.PROMPT_PRIZE_DESC_2.text = 'SPINS';
		this.wrapper.PROMPT_PRIZE_DESC_2.position.x =
			this.wrapper.PROMPT_PRIZE.getBounds().x +
			this.wrapper.PROMPT_PRIZE.getBounds().width +
			25;
		this.wrapper.PROMPT_PRIZE_DESC.text = 'SPIN PRICE';
		if (this.currency[1] === 'left') {
			this.wrapper.PROMPT_AMOUNT.text =
				this.currency[0] +
				GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level];
		} else {
			this.wrapper.PROMPT_AMOUNT.text =
				GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level] +
				(GameConfigs.auth.balance.currency === 'GEL'
					? '' + this.currency[0]
					: ' ' + this.currency[0]);
		}
	}

	generateBetDiscount() {
		let line = new Graphics();
		line.clear();
		line.lineStyle(3, 0x29c6c8, 1);
		this.wrapper.PROMPT_DESC.text = `YOU WILL GET ${GameConfigs.quest_claim.item.prize.config.discount}% DISCOUNTED`;
		// this.wrapper.PROMPT_DESC.text = `YOU WILL GET ${GameConfigs.quest_claim.item.prize.config.discount}X WIN`;
		this.wrapper.PROMPT_PRIZE.text =
			GameConfigs.quest_claim.item.prize.count -
			GameConfigs.quest_claim.item.claimed;
		this.wrapper.PROMPT_PRIZE.anchor.x = 1;
		this.wrapper.PROMPT_PRIZE.position.x = this.wrapper.getBounds().width / 2;
		this.wrapper.PROMPT_PRIZE_DESC_2.text = 'SPINS';
		this.wrapper.PROMPT_PRIZE_DESC_2.position.x =
			this.wrapper.PROMPT_PRIZE.getBounds().x +
			this.wrapper.PROMPT_PRIZE.getBounds().width +
			25;
		this.wrapper.PROMPT_PRIZE_DESC.text = 'SPIN PRICE';
		this.wrapper.PROMPT_PRIZE_DESC.position.x =
			this.wrapper.getBounds().width / 2 - 30;

		const PROMPT_PRIZE_DESC_WIDTH = TextMetrics.measureText(
			this.wrapper.PROMPT_PRIZE_DESC.text,
			this.wrapper.PROMPT_PRIZE_DESC.style
		).width;

		if (this.currency[1] === 'left') {
			this.wrapper.PROMPT_PRIZE_DISCOUNT.text =
				this.currency[0] +
				GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level];
		} else {
			this.wrapper.PROMPT_PRIZE_DISCOUNT.text =
				GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level] +
				(GameConfigs.auth.balance.currency === 'GEL'
					? '' + this.currency[0]
					: ' ' + this.currency[0]);
		}

		this.wrapper.PROMPT_PRIZE_DISCOUNT.alpha = 0.5;

		const amount = (
			GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level] -
			(GameConfigs.config.bet_steps[GameConfigs.quest_claim.bet_level] *
				GameConfigs.quest_claim.item.prize.config.discount) /
				100
		).toLocaleString(undefined, {
			minimumFractionDigits: GameConfigs.config.currency_prec,
			maximumFractionDigits: GameConfigs.config.currency_prec
		});
		this.wrapper.PROMPT_PRIZE_DISCOUNT.position.x =
			this.wrapper.PROMPT_PRIZE_DESC.getBounds().x +
			PROMPT_PRIZE_DESC_WIDTH +
			10;
		if (this.currency[1] === 'left') {
			this.wrapper.PROMPT_AMOUNT.text = this.currency[0] + amount;
		} else {
			this.wrapper.PROMPT_AMOUNT.text =
				amount +
				(GameConfigs.auth.balance.currency === 'GEL'
					? '' + this.currency[0]
					: ' ' + this.currency[0]);
		}

		let x =
			this.wrapper.PROMPT_PRIZE_DISCOUNT.getBounds().width / 1.4 +
			this.wrapper.PROMPT_PRIZE_DISCOUNT.position.x;
		let y = this.wrapper.PROMPT_PRIZE_DISCOUNT.position.y + 15;
		line.moveTo(this.wrapper.PROMPT_PRIZE_DISCOUNT.position.x, y);
		line.lineTo(x, y);
		this.wrapper.addChild(line);
	}

	capitalizeWords(str) {
		let prize = str.split('_').join(' ');
		return prize.toUpperCase();
	}

	removeEvents() {}

	handler() {
		if (GameConfigs.reelComponent.rotating) return;
		if (!this.enabled) return;
		this.enabled = false;
		// let step = false;
		if (GameConfigs.doubleChance) {
			HELPERS.dispatchCustomEvent(EVENTS.DOUBLE_CHANCE, {
				doubleChance: false
			});
		}
		HELPERS.dispatchCustomEvent(EVENTS.QUEST_CLAIM, {
			quest_claim: {
				...GameConfigs.quest_claim,
				activated_item: GameConfigs.quest_claim.pending_item
				// pending_item: 0,
			}
		});
		GameConfigs.quest_is_active = true;

		let quest_current = GameConfigs.quest_parsed.items.find(
			(item) => item.item.id === GameConfigs.quest_claim.activated_item
		);
		GameConfigs.quest_current = quest_current;
		GameConfigs.quest_current = {
			...GameConfigs.quest_current,
			claimed: GameConfigs.quest_current
				? GameConfigs.quest_current.claimed
				: GameConfigs.quest_claim.item.prize.count -
					GameConfigs.quest_claim.item.claimed
		};
		if (GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]) {
			GameConfigs.uiComponent.removeView(
				GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]
			);
		}
		if (GameConfigs.quest_claim.item.step) {
			GameConfigs.uiComponent.addView(QuestStatusBarView);
		}

		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		HELPERS.dispatchCustomEvent(EVENTS.BET_UPDATE, {
			betAmount: GameConfigs.config.bet_steps[GameConfigs.quest.bet_level]
		});

		this.sendBet();
	}

	close() {
		window.sm.play({ name: 'bonus_buy_quest_close_sfx' });
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		GameConfigs.quest_claim.activated_item = 0;
		GameConfigs.quest_claim.pending_item = 0;
	}

	sendBet() {
		//send bet request
		window.connectionProvider.bet(
			JSON.stringify({
				service: 'bet',
				data: {
					amount:
						GameConfigs.config.bet_steps[
							GameConfigs.quest.bet_level
						].toString(),
					doublefeaturechance: 0,
					buybonus: 0,
					questid: GameConfigs.quest_claim.activated_item
				}
			})
		);
		//trow event - bet is placed
		// GameConfigs.betPlaced = true;
		HELPERS.dispatchCustomEvent(EVENTS.BET_PLACED, { placed: true });
		//play spin sound
		// window.sm.play({ name: "spin_sfx" });
	}
}
export default PromptController;
